var hourlySalesData = [
    {
        'RPT_HOURLY_SALES_ID': 13275948,
        'HIERARCHY_ID': 757,
        'TIME_DIM_ID': 1710445,
        'HOUR_NUM': 12,
        'HOUR_START_STR': '11:00a',
        'HOUR_END_STR': '11:59a',
        'HOUR_STR': '11:00a - 11:59a',
        'SALES_AMT': 289.54,
        'SALES_CNT': 3,
        'SALES_PCT': 4.69,
        'GUEST_CNT': 3,
        'COVER_CNT': 0,
        'LOAD_TIME': '2020-04-01T19:25:00',
        'BUSINESS_DATE': '2020-04-01T00:00:00'
    },
    {
        'RPT_HOURLY_SALES_ID': 13275949,
        'HIERARCHY_ID': 757,
        'TIME_DIM_ID': 1710445,
        'HOUR_NUM': 13,
        'HOUR_START_STR': '12:00p',
        'HOUR_END_STR': '12:59p',
        'HOUR_STR': '12:00p - 12:59p',
        'SALES_AMT': 173.21,
        'SALES_CNT': 8,
        'SALES_PCT': 2.8,
        'GUEST_CNT': 10,
        'COVER_CNT': 0,
        'LOAD_TIME': '2020-04-01T19:25:00',
        'BUSINESS_DATE': '2020-04-01T00:00:00'
    },
    {
        'RPT_HOURLY_SALES_ID': 13275950,
        'HIERARCHY_ID': 757,
        'TIME_DIM_ID': 1710445,
        'HOUR_NUM': 14,
        'HOUR_START_STR': '1:00p',
        'HOUR_END_STR': '1:59p',
        'HOUR_STR': '1:00p - 1:59p',
        'SALES_AMT': 492.51,
        'SALES_CNT': 17,
        'SALES_PCT': 7.97,
        'GUEST_CNT': 28,
        'COVER_CNT': 0,
        'LOAD_TIME': '2020-04-01T19:25:00',
        'BUSINESS_DATE': '2020-04-01T00:00:00'
    },
    {
        'RPT_HOURLY_SALES_ID': 13275951,
        'HIERARCHY_ID': 757,
        'TIME_DIM_ID': 1710445,
        'HOUR_NUM': 15,
        'HOUR_START_STR': '2:00p',
        'HOUR_END_STR': '2:59p',
        'HOUR_STR': '2:00p - 2:59p',
        'SALES_AMT': 870.22,
        'SALES_CNT': 25,
        'SALES_PCT': 14.09,
        'GUEST_CNT': 41,
        'COVER_CNT': 0,
        'LOAD_TIME': '2020-04-01T19:25:00',
        'BUSINESS_DATE': '2020-04-01T00:00:00'
    },
    {
        'RPT_HOURLY_SALES_ID': 13275952,
        'HIERARCHY_ID': 757,
        'TIME_DIM_ID': 1710445,
        'HOUR_NUM': 16,
        'HOUR_START_STR': '3:00p',
        'HOUR_END_STR': '3:59p',
        'HOUR_STR': '3:00p - 3:59p',
        'SALES_AMT': 539.36,
        'SALES_CNT': 23,
        'SALES_PCT': 8.73,
        'GUEST_CNT': 31,
        'COVER_CNT': 0,
        'LOAD_TIME': '2020-04-01T19:25:00',
        'BUSINESS_DATE': '2020-04-01T00:00:00'
    },
    {
        'RPT_HOURLY_SALES_ID': 13275953,
        'HIERARCHY_ID': 757,
        'TIME_DIM_ID': 1710445,
        'HOUR_NUM': 17,
        'HOUR_START_STR': '4:00p',
        'HOUR_END_STR': '4:59p',
        'HOUR_STR': '4:00p - 4:59p',
        'SALES_AMT': 489.96,
        'SALES_CNT': 16,
        'SALES_PCT': 7.93,
        'GUEST_CNT': 25,
        'COVER_CNT': 0,
        'LOAD_TIME': '2020-04-01T19:25:00',
        'BUSINESS_DATE': '2020-04-01T00:00:00'
    },
    {
        'RPT_HOURLY_SALES_ID': 13275954,
        'HIERARCHY_ID': 757,
        'TIME_DIM_ID': 1710445,
        'HOUR_NUM': 18,
        'HOUR_START_STR': '5:00p',
        'HOUR_END_STR': '5:59p',
        'HOUR_STR': '5:00p - 5:59p',
        'SALES_AMT': 719.31,
        'SALES_CNT': 23,
        'SALES_PCT': 11.65,
        'GUEST_CNT': 35,
        'COVER_CNT': 0,
        'LOAD_TIME': '2020-04-01T19:25:00',
        'BUSINESS_DATE': '2020-04-01T00:00:00'
    },
    {
        'RPT_HOURLY_SALES_ID': 13275955,
        'HIERARCHY_ID': 757,
        'TIME_DIM_ID': 1710445,
        'HOUR_NUM': 19,
        'HOUR_START_STR': '6:00p',
        'HOUR_END_STR': '6:59p',
        'HOUR_STR': '6:00p - 6:59p',
        'SALES_AMT': 563.84,
        'SALES_CNT': 14,
        'SALES_PCT': 9.13,
        'GUEST_CNT': 25,
        'COVER_CNT': 0,
        'LOAD_TIME': '2020-04-01T19:25:00',
        'BUSINESS_DATE': '2020-04-01T00:00:00'
    },
    {
        'RPT_HOURLY_SALES_ID': 13275956,
        'HIERARCHY_ID': 757,
        'TIME_DIM_ID': 1710445,
        'HOUR_NUM': 20,
        'HOUR_START_STR': '7:00p',
        'HOUR_END_STR': '7:59p',
        'HOUR_STR': '7:00p - 7:59p',
        'SALES_AMT': 999.29,
        'SALES_CNT': 28,
        'SALES_PCT': 16.18,
        'GUEST_CNT': 43,
        'COVER_CNT': 0,
        'LOAD_TIME': '2020-04-01T19:25:00',
        'BUSINESS_DATE': '2020-04-01T00:00:00'
    },
    {
        'RPT_HOURLY_SALES_ID': 13275957,
        'HIERARCHY_ID': 757,
        'TIME_DIM_ID': 1710445,
        'HOUR_NUM': 21,
        'HOUR_START_STR': '8:00p',
        'HOUR_END_STR': '8:59p',
        'HOUR_STR': '8:00p - 8:59p',
        'SALES_AMT': 427.37,
        'SALES_CNT': 14,
        'SALES_PCT': 6.92,
        'GUEST_CNT': 23,
        'COVER_CNT': 0,
        'LOAD_TIME': '2020-04-01T19:25:00',
        'BUSINESS_DATE': '2020-04-01T00:00:00'
    },
    {
        'RPT_HOURLY_SALES_ID': 13275958,
        'HIERARCHY_ID': 757,
        'TIME_DIM_ID': 1710445,
        'HOUR_NUM': 22,
        'HOUR_START_STR': '9:00p',
        'HOUR_END_STR': '9:59p',
        'HOUR_STR': '9:00p - 9:59p',
        'SALES_AMT': 224.82,
        'SALES_CNT': 6,
        'SALES_PCT': 3.64,
        'GUEST_CNT': 7,
        'COVER_CNT': 0,
        'LOAD_TIME': '2020-04-01T19:25:00',
        'BUSINESS_DATE': '2020-04-01T00:00:00'
    },
    {
        'RPT_HOURLY_SALES_ID': 13275959,
        'HIERARCHY_ID': 757,
        'TIME_DIM_ID': 1710445,
        'HOUR_NUM': 23,
        'HOUR_START_STR': '10:00p',
        'HOUR_END_STR': '10:59p',
        'HOUR_STR': '10:00p - 10:59p',
        'SALES_AMT': 201.69,
        'SALES_CNT': 6,
        'SALES_PCT': 3.27,
        'GUEST_CNT': 9,
        'COVER_CNT': 0,
        'LOAD_TIME': '2020-04-01T19:25:00',
        'BUSINESS_DATE': '2020-04-01T00:00:00'
    },
    {
        'RPT_HOURLY_SALES_ID': 13275960,
        'HIERARCHY_ID': 757,
        'TIME_DIM_ID': 1710445,
        'HOUR_NUM': 24,
        'HOUR_START_STR': '11:00p',
        'HOUR_END_STR': '11:59p',
        'HOUR_STR': '11:00p - 11:59p',
        'SALES_AMT': 105.4,
        'SALES_CNT': 3,
        'SALES_PCT': 1.71,
        'GUEST_CNT': 5,
        'COVER_CNT': 0,
        'LOAD_TIME': '2020-04-01T19:25:00',
        'BUSINESS_DATE': '2020-04-01T00:00:00'
    },
    {
        'RPT_HOURLY_SALES_ID': 13275961,
        'HIERARCHY_ID': 757,
        'TIME_DIM_ID': 1710445,
        'HOUR_NUM': 25,
        'HOUR_START_STR': '12:00a',
        'HOUR_END_STR': '12:59a',
        'HOUR_STR': '12:00a - 12:59a',
        'SALES_AMT': 80.27,
        'SALES_CNT': 12,
        'SALES_PCT': 1.3,
        'GUEST_CNT': 12,
        'COVER_CNT': 0,
        'LOAD_TIME': '2020-04-01T19:25:00',
        'BUSINESS_DATE': '2020-04-01T00:00:00'
    }
]

export default hourlySalesData